import 'src/global.css';

import { useEffect } from 'react';

import { Router } from 'src/app/router';
import { initGA, logPageView } from 'src/lib/analytics';
import { useThemeSideEffects } from 'src/stores/theme-store';
import { applyUpdate, checkForUpdates } from 'src/app-update';
import { useScrollToTop } from 'src/app/hooks/use-scroll-to-top';
import { SubscriptionProvider } from 'src/features/subscription/providers/subscription-provider';
import { NotificationProvider } from 'src/features/notifications/providers/notification-realtime-provider';

import { Iconify } from 'src/components/common/iconify';

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();
  useThemeSideEffects();

  useEffect(() => {
    initGA();
    logPageView(); // Log initial page view

    // Check for updates when the app starts
    const checkVersion = async () => {
      const hasUpdate = await checkForUpdates();
      if (hasUpdate) {
        // Wait 3 seconds before applying the update to avoid disrupting the user experience
        console.log('Update available, applying automatically in 3 seconds...');
        setTimeout(() => {
          applyUpdate();
        }, 3000);
      }
    };

    checkVersion();

    // Set up periodic checks (every 15 minutes)
    const interval = setInterval(checkVersion, 15 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  // Track page views on route changes
  useEffect(() => {
    const handleRouteChange = () => {
      logPageView();
    };

    window.addEventListener('popstate', handleRouteChange);
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  const githubButton = (
    <a
      href="https://github.com/Rorogogogo/Jobjourney-extention"
      aria-label="Github"
      className="fixed bottom-5 right-5 z-10 flex size-11 items-center justify-center rounded-full bg-neutral-800 text-white shadow-lg transition-transform hover:scale-110"
    >
      <Iconify width={24} icon="eva:github-fill" />
    </a>
  );

  return (
    <SubscriptionProvider>
      <NotificationProvider>
        <Router />
        {githubButton}
      </NotificationProvider>
    </SubscriptionProvider>
  );
}
